import React from 'react';
import SearchIconSvgSm from '../../../svgs/SearchIconSvgSm';

import styles from './index.module.scss';

type SearchBarProps = {
	onChange: React.ChangeEventHandler<HTMLInputElement>;
	value: string;
};

export const SearchBar = React.forwardRef(
	({ onChange, value }: SearchBarProps, ref: React.LegacyRef<HTMLInputElement> | undefined) => {
		return (
			<section
				className={`${styles.wrapper} flex items-center flex-1 shadow-md md:shadow-none bg-[#ffffff] md:bg-[#f1f4f8] rounded-[30px] md:rounded-[8px] gap-2`}
			>
				<SearchIconSvgSm />

				<aside className="flex-1">
					<input
						ref={ref}
						autoCorrect="false"
						spellCheck="false"
						placeholder="Scan or search"
						type="text"
						value={value}
						onChange={onChange}
						className=" w-100"
						id="disable-autofill"
						name="disableAutofillFill"
						autoComplete="off"
					/>
				</aside>
			</section>
		);
	}
);
